import React, { useState, useMemo } from 'react';
import { Checkbox, Button, Divider, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from '../UserActions.module.scss';

export const CheckboxFilter = ({
  selectedKeys,
  setSelectedKeys,
  confirm,
  close,
  allOptions,
  getLabel,
  onApply,
  onReset,
}) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');

  const options = useMemo(() => {
    const filtered = search
      ? allOptions.filter(opt => String(opt).toLowerCase().includes(search.toLowerCase()))
      : allOptions;
    return filtered.map(value => ({ label: getLabel ? getLabel(value) : value, value }));
  }, [allOptions, search, getLabel]);

  return (
    <div className={styles.box}>
      {allOptions.length > 5 && (
        <Input
          placeholder={t('userActions.searchPlaceholder')}
          value={search}
          onChange={e => setSearch(e.target.value)}
          allowClear
          size="small"
          style={{ marginBottom: 8 }}
        />
      )}
      <Checkbox.Group
        className={styles.checkboxGroup}
        options={options}
        value={selectedKeys}
        onChange={setSelectedKeys}
      />
      <Divider className={styles.divider} />
      <div className={styles.wrapButton}>
        <Button
          size="small"
          onClick={() => {
            setSelectedKeys([]);
            onReset();
            confirm();
          }}
        >
          {t('userActions.reset')}
        </Button>
        <Button
          size="small"
          type="primary"
          onClick={() => {
            onApply(selectedKeys);
            close();
            confirm();
          }}
        >
          {t('userActions.choose')}
        </Button>
      </div>
    </div>
  );
};
